import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { ButtonCoreDriver } from '../Button/ButtonCore/ButtonCore.uni.driver';
import { UniDriverFactory } from '@wix/wix-ui-test-utils/uni-driver-factory';

export interface IconButtonUniDriver extends BaseUniDriver {
  isButtonDisabled: ButtonCoreDriver['isButtonDisabled'];
  isFocused: () => Promise<boolean>;
}

export declare const iconButtonDriverFactory: UniDriverFactory<IconButtonUniDriver>;
